import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API_BASE } from "../api";
import BaseLayout from "./BaseLayout";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState({ type: "", content: "" });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage({ type: "", content: "" });
    setSubmitting(true);

    try {
      const response = await axios.post(`${API_BASE}/mail/forgot-password`, { email });
      setMessage({ type: "success", content: response.data.message });
    } catch (error) {
      if (error.response) {
        setMessage({ type: "error", content: error.response.data.error || error.response.data.message });
      } else {
        setMessage({ type: "error", content: "An error occurred. Please try again." });
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <BaseLayout>
      <div className="auth-wrapper">
        <img src="/loginlogo.png" className="auth-logo" alt="FlamePicks" />
        <div className="auth-card">
          {message.content && (
            <div
              className={`alert ${message.type === "error" ? "alert-danger" : "alert-success"}`}
              role="alert"
            >
              {message.content}
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                placeholder="Enter your account email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="auth-submit-btn" disabled={submitting}>
              {submitting ? "Sending..." : "Send Reset Link"}
            </button>
          </form>
          <div className="auth-footer-link">
            Remember your password? <Link to="/login">Sign in</Link>
          </div>
        </div>
      </div>
    </BaseLayout>
  );
};

export default ForgotPasswordPage;
